import { SportPlay } from "../types";

export type BasePlayDataErrors = {
  play?: string;
  name?: string;
};

export const validatePlayData = (playData: SportPlay | undefined): BasePlayDataErrors => {
  const name = playData?.name;

  let errors: BasePlayDataErrors = {};

  if (!name || name === "") {
    errors = { ...errors, name: "Name is required" };
  }

  return errors;
};
